import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DatePicker } from 'antd';
import moment from 'moment';
import styled from 'styled-components';
const { RangePicker } = DatePicker;

const Range = styled(RangePicker)`
  &&& {
    border: none;
    box-shadow: none;
    background: transparent;
    .ant-picker-range-separator {
      display: none;
    }
    .ant-picker-suffix {
      display: none;
    }
    .ant-picker-input {
      height: 50px;
      background: white;

      padding: 0;
      border-radius: 8px;
      padding-left: 10px;
      padding-right: 20px;
      &:nth-child(1) {
        margin-right: 15px;
      }
    }
    .ant-picker-active-bar {
      display: none;
    }
  }
`;

function RangeDate({ getData }) {
  const { t } = useTranslation();
  const onChange = (dates) => {
    if (dates) {
      getData({
        start: moment(dates[0]).format('YYYY-MM-DD'),
        end: moment(dates[1]).add(1, 'days').format('YYYY-MM-DD'),
      });
    } else {
      getData();
    }
  };

  return (
    <Range
      placeholder={[t('ddmmyyyy'), t('ddmmyyyy')]}
      ranges={{
        [`${t('today')}`]: [moment(), moment()],
        [`${t('thisMonth')}`]: [
          moment().startOf('month'),
          moment().endOf('month'),
        ],
      }}
      format="DD MMMM YYYY"
      onChange={onChange}
    />
  );
}

RangeDate.propTypes = {};

export default RangeDate;
